import { User } from './user.interface'

export interface PropertySchema {
  key: string
  value: unknown | unknown[]
  value_type: string
}

export type PropertiesV1 = PropertySchema[]

export interface PropertiesV2 {
  item_experiance: PropertySchema[]
  common: {
    standard: PropertySchema[]
    '2d_spec': PropertySchema[]
    '3d_spec': PropertySchema[]
    sound_spec: PropertySchema[]
  }
}

export type Properties = PropertiesV1 | PropertiesV2 | PropertiesV3

export interface NftTokenSchema {
  _id: string
  address: string
  owner: string
  _tokenId: number
  _quantity: number
  _bucketHash: string
  creationBlock: number
  description: string
  image: string
  minifiedImage?: string
  extraFiles?: string[]
  tokenName: string
  createdBy: string
  initialOwner: string
  favorites?: number
  wishes?: number
  properties?: Properties
  createdAt: string
  updatedAt: string
  transactionHash: string
  burn: boolean
}

export enum Network {
  BNB_CHAIN = 'bnb-chain',
  ETHEREUM = 'ethereum',
  POLYGON = 'polygon',
  ARBITRUM = 'arbitrum',
  BASE = 'base'
}

export enum ProtocolsEnum {
  METAPROTOCOL = 'metaprotocol',
  CITIZEN_CONFLICT = 'citizenconflict',
  WIZARRE = 'wizarre',
  APES_PLANET = 'apesplanet',
  PIRATES_OF_THE_ARRLAND = 'piratesofthearrland',
  MAGIC_CRAFT = 'magiccraft',
  CRYPTO_MAYHEM = 'cryptomayhem',
  ACADEMY_VERSE = 'academyverse',
  KRYXIVIA = 'kryxivia',
  HAREVERSE = 'hareverse',
  ROBOHERO = 'robohero',
  HEROES_BATTLE_ARENA = 'heroesbattlearena',
  METARRIOR_HERO = 'metarriorhero',
  LEGENDS_OF_ELYSIUM = 'legendsofelysium',
  PLAYERMON = 'playermon',
  LAMBORGHINI = 'lamborghini',
  MEDIEVAL_EMPIRES = 'medievalempires'
}

export enum NftStandard {
  ERC_721 = 'erc721',
  ERC_1155 = 'erc1155',
  ERC_20 = 'erc20'
}

export interface NftSchema {
  address: string
  contractAddress: string
  standard: NftStandard
  protocol: ProtocolsEnum
  network: Network
  creationBlock: number
  createdAt: string
  createdBy: string
  version: number
  isListed: boolean
  isAsset: boolean
  symbol?: string
  chainId: number
  token: NftTokenSchema
}

export interface TagSchema {
  tagId: number
  name: string
  _id?: string
  createdAt?: Date
  usage?: number
  updatedAt?: Date
}

export interface NftCategory {
  name: string
  categoryId: number
  parentId?: number
  usage?: number
  createdAt?: Date
  updatedAt?: Date
}

export enum MetaAssetType {
  TWO_DIMENSIONAL = '2D meta asset',
  THREE_DIMENSIONAL = '3D meta asset',
  SOUND = 'Sound meta asset'
}

export enum MetaAssetLicence {
  ROYALTY_FREE = 'Royalty Free (RF)',
  RIGHTS_MANAGED = 'Rights Managed (RM)',
  CREATIVE_COMMONS = 'Creative Commons (CC)'
}

export enum MetaAssetRestriction {
  PUBLIC = 'Public meta asset',
  RESTRICTED = 'Restricted meta asset'
}

export interface TokenDetails {
  tokenDetails: NftSchema
  creatorUsername: string
  contractAddress: string
}

export enum MetaAssetGeometry {
  POLYGONAL_QUADS_ONLY = 'Polygonal Quads only',
  POLYGONAL_QUADS_TRIS = 'Polygonal Quads/Tris',
  POLYGONAL_TRIS_ONLY = 'Polygonal Tris only',
  POLYGONAL_QUADS_NGONS = 'Polygonal Ngons',
  POLYGONAL_SUBDIVISION = 'Polygonal, Subdivision',
  NURBS = 'NURBS',
  UNKNOWN = 'Unknown'
}

export enum MetaAssetChain {
  BNB = 'BNB Chain',
  ETHEREUM = 'Ethereum',
  POLYGON = 'Polygon',
  ARBITRUM = 'Arbitrum',
  BASE = 'Base'
}

export enum MetaAssetSampleRate {
  KHZ_44_1 = '44.1 kHz',
  KHZ_48 = '48 kHz'
}

export enum MetaAssetChannel {
  STEREO = 'Stereo',
  MONO = 'Mono'
}

// Property
export enum PropertyType {
  BOOST_PERCENTAGE = 'boost_percentage',
  BOOST_NUMBER = 'boost_number',
  LEVEL = 'level'
}

export enum AttributeType {
  BOOST_PERCENTAGE = 'boost_percentage',
  BOOST_NUMBER = 'boost_number',
  NUMBER = 'number',
  DATE = 'date'
}

export interface FilesSchema {
  key: string
  value: unknown | unknown[]
  value_type: string
}

export interface PropertyV3Schema {
  name: string
  value: string | number
  display_value?: string
  display_type?: PropertyType
  max_value?: number
}

export interface PropertiesV3 {
  [key: string]: string | PropertyV3Schema
}

export enum SortNftKey {
  TOKEN_TOKEN_ID = 'token._tokenId',
  TOKEN_ID = '_tokenId',
  CREATED_AT = 'createdAt',
  QUANTITY = '_quantity',
  TOKEN_CREACTION_BLOCK = 'token.creationBlock',
  TOKEN_FAVORITES = 'token.favorites',
  TOKEN_NAME = 'token.tokenName'
}

export interface RichNftData {
  token: NftSchema
  user?: User
}

export interface TokenData {
  contractAddress: string
  tokenId: number
}

export interface AssetPropertyBase {
  value: number | boolean | string | string[]
  valueType: string
}

export interface ExtendedAssetProperty {
  key: string
  title: string
  unitName?: string
  additionalLabel?: string
}

export type RichAssetProperties = AssetPropertyBase & ExtendedAssetProperty

export interface AssetProperty {
  [type: string]: RichAssetProperties
}

export interface AssetProperties {
  [propertyName: string]: AssetProperty
}

export interface CollectionQP {
  createdBy: string
  collectionName: string
}
